// extracted by css-extract-rspack-plugin
export default {"bottom-wrapper":"BalanceAndBonuses-module__bottom-wrapper--NoQdB","bottomWrapper":"BalanceAndBonuses-module__bottom-wrapper--NoQdB"};